import { useBranding } from '@/lib/branding-context';
import { Link } from 'react-router';

export default function HomePage() {
  const { branding } = useBranding();

  return (
    <main className="relative min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800 flex flex-col items-center justify-center">
      {branding.appLogoUrl && (
        <img
          src={branding.appLogoUrl}
          alt={branding.appName}
          className="absolute top-6 left-6 z-10 h-10 max-w-[min(10rem,40vw)] w-auto object-contain"
        />
      )}
      <Link
        to="/login"
        className="absolute top-6 right-6 z-10 inline-flex items-center text-sm text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-300"
      >
        Login
      </Link>

      <div className="container mx-auto px-4 py-10 max-w-2xl flex flex-col w-full">

        {/* Header */}
        <header className="text-center mb-10">
          <h1 className="mb-3 text-3xl sm:text-4xl font-bold text-slate-900 dark:text-white">
            {branding.appName}
          </h1>
          <p className="text-slate-600 dark:text-slate-400 max-w-xl mx-auto">
            How would you like to participate today?
          </p>
        </header>

        {/* Choice cards */}
        <section className="flex-1 flex flex-col gap-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <Link
              to="/submit"
              className="group rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-6 flex items-center justify-center shadow-sm hover:shadow-md transition-shadow"
            >
              <h2 className="text-lg font-semibold text-slate-900 dark:text-white">
                Submit a prayer
              </h2>
            </Link>

            <Link
              to="/pray"
              className="group rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-6 flex items-center justify-center shadow-sm hover:shadow-md transition-shadow"
            >
              <h2 className="text-lg font-semibold text-slate-900 dark:text-white">
                View and pray for others
              </h2>
            </Link>
          </div>

          {/* Footer */}
          <footer className="mt-8 pt-6 border-t border-slate-200 dark:border-slate-700 text-center">
          </footer>
        </section>
      </div>
    </main>
  );
}
